import React, { useMemo, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import PbUmkuService from '../../../../services/pbumku/PbumkuService';
import ModalCetakLamp from './ModalCetakLamp';

const ModalViewLampTeknis = ({ showViewLampiran, handleCloseViewLampiran, rowData, laporanFile, lampiranTeknis, dataOssHeader, dataProyek, dataProyekLokasi, reloadList }) => {

    const [showCetakLampiran, setShowCetakLampiran] = useState(false)
    const handleCloseCetakLampiran = () => setShowCetakLampiran(false)

    const handleClickCetakLampiran = () => {
        setShowCetakLampiran(true)
    }

    return (
        <>
            <Modal show={showViewLampiran} onHide={handleCloseViewLampiran} backdrop='static' keyboard={false} scrollable={true} size='xl' centered>
                <Modal.Header><h6>Form Lampiran Teknis</h6></Modal.Header>
                <Modal.Body>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm">Perizinan</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-12 form-control-sm" name="nib" defaultValue={rowData !== null && rowData.urIzin} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm">NIB / Nama Perusahaan</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-12 form-control-sm" name="nib" defaultValue={rowData !== null && (rowData.nib + ' / ' + rowData.namaPerseroan)} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm">Nomor / Tanggal Permohonan</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-12 form-control-sm" name="idIzin" defaultValue={rowData !== null && rowData.idIzin + ' / ' + rowData.tglPermohonan} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm">Nomor Kegiatan Usaha</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-12 form-control-sm" name="nomor_proyek" defaultValue={rowData !== null && rowData.nomorProyek} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm">Usaha</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-12 form-control-sm" name="nib" defaultValue={rowData !== null && rowData.uraianUsaha} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm">Nomor / Tanggal SPT</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-12 form-control-sm" name="nib" defaultValue={rowData !== null && rowData.nomorSpt + ' / ' + rowData.tanggalSpt} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm">Nomor Referensi Teknis</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-8 form-control-sm" name="nomor_ref" defaultValue={lampiranTeknis !== null ? lampiranTeknis.nomorReferensiTeknis : ''} disabled />{' '}
                        </div>
                    </div>

                    {
                        rowData !== null && (rowData.urIzinSingkat === 'CBIB' || rowData.urIzinSingkat === 'CPIB') &&
                        <div className="row mb-3">
                            <label className="col-sm-4 col-form-label-sm">Komoditas</label>
                            <div className="col-sm-8">
                                <input type="text" className="col-sm-8 form-control-sm" name="komoditas" defaultValue={lampiranTeknis !== null ? lampiranTeknis.komoditas : ''} disabled />{' '}
                            </div>
                        </div>
                    }
                    {
                        rowData !== null && rowData.urIzinSingkat === 'CDOIB' &&
                        <div className="row mb-3">
                            <label className="col-sm-4 col-form-label-sm">Kategori</label>
                            <div className="col-sm-8">
                                <input type="text" className="col-sm-8 form-control-sm" name="kategori" defaultValue={lampiranTeknis !== null ? lampiranTeknis.kategori : ''} disabled />{' '}
                            </div>
                        </div>
                    }
                    {
                        rowData !== null && rowData.urIzinSingkat === 'CPOIB' &&
                        <>
                            <div className="row mb-3">
                                <label className="col-sm-4 col-form-label-sm">Kategori</label>
                                <div className="col-sm-8">
                                    <input type="text" className="col-sm-8 form-control-sm" name="kategori" defaultValue={lampiranTeknis !== null ? lampiranTeknis.kategori : ''} disabled />{' '}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-4 col-form-label-sm">Jenis Sediaan Obat</label>
                                <div className="col-sm-8">
                                    <input type="text" className="col-sm-8 form-control-sm" name="sediaan_obat" defaultValue={lampiranTeknis !== null ? lampiranTeknis.jenisSediaanObat : ''} disabled />{' '}
                                </div>
                            </div>
                        </>
                    }
                    {
                        rowData !== null && rowData.urIzinSingkat === 'CPPIB' &&
                        <div className="row mb-3">
                            <label className="col-sm-4 col-form-label-sm">Peruntukan Produk</label>
                            <div className="col-sm-8">
                                <input type="text" className="col-sm-8 form-control-sm" name="peruntukan" defaultValue={lampiranTeknis !== null ? lampiranTeknis.peruntukanProduk : ''} disabled />{' '}
                            </div>
                        </div>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" size="sm" onClick={() => handleClickCetakLampiran()} >Cetak</Button>{' '}
                    <Button variant="danger" size="sm" onClick={handleCloseViewLampiran}>
                        Batal
                    </Button>
                </Modal.Footer>
            </Modal>
            <ModalCetakLamp showCetakLamp={showCetakLampiran} handleCloseCetakLamp={handleCloseCetakLampiran} rowData={rowData} laporanFile={laporanFile} lampiranTeknis={lampiranTeknis} dataOssHeader={dataOssHeader} dataProyek={dataProyek} dataProyekLokasi={dataProyekLokasi}/>
        </>
    )
}

export default ModalViewLampTeknis